import React from 'react'
import { AnalysisMap } from '@popety-io/ui'
import { useMapSectionData } from '../contexts'

interface BuildingAnalysisMapProps {
  buildingId: string
  coordinates?: [number, number]
  geoJson?: any
  buildingGeoJson?: any
  buildingHeight?: number
  /** Terrain-relative height for a single building; leaves legacy fallbacks intact. */
  buildingDisplayHeight?: number
  buildingClassification?: string
  onResizeStart: () => void
}

export const BuildingAnalysisMap: React.FC<BuildingAnalysisMapProps> = ({
  buildingId,
  coordinates,
  geoJson,
  buildingGeoJson,
  buildingHeight,
  buildingDisplayHeight,
  buildingClassification,
  onResizeStart,
}) => {
  const {
    activeSection,
    sectionData,
    hoveredItemId,
    selectedItemId,
    setSelectedItemId,
    flyToCoordinates,
    onItemClick,
  } = useMapSectionData()

  if (!buildingId || !coordinates) {
    return null
  }

  return (
    <AnalysisMap
      isPublic
      propertyId={buildingId}
      coordinates={coordinates}
      geoJson={geoJson}
      buildingGeoJson={buildingGeoJson}
      buildingHeight={buildingHeight}
      buildingDisplayHeight={buildingDisplayHeight}
      buildingClassification={buildingClassification}
      analysisType="building"
      activeSection={activeSection}
      sectionData={sectionData}
      hoveredItemId={hoveredItemId}
      selectedItemId={selectedItemId}
      setSelectedItemId={setSelectedItemId}
      flyToCoordinates={flyToCoordinates}
      onItemClick={onItemClick}
      onResizeStart={onResizeStart}
      uiConfig={{
        showLayersButton: true,
        showLegendButton: false,
        show3DButton: true,
        showLocationButton: true,
        showZoomControls: true,
      }}
    />
  )
}
